const BUTTON_SUCCESS_TIMEOUT_MS = 1.5 * 1000;

const FORM_PORTAL_ID = '21175391';

// used on the Talk to Sales page (/talk-to-sales) in the Hero component
const TALK_TO_SALES_FORM_ID = 2;

// used on the Book a Demo page (/book-a-demo) in the Hero component
const BOOK_A_DEMO_FORM_ID = 3;

// used on the Get a Demo page (/get-a-demo) in the Hero component
const GET_A_DEMO_FORM_ID = 14;

// used on the Become a Partner page (/become-a-partner) in the Hero component
const BECOME_A_PARTNER_FORM_ID = 4;

// used on the Integrations page (/integrations) in the Partner component
const BECOME_A_PARTNER_FORM_SMALL_ID = 17;

// used on the Request a Migration Plan page (/request-a-migration-plan) in the Hero component
const REQUEST_A_MIGRATION_PLAN_FORM_ID = 5;

// used on the Contact Us page in the Hero component
const CONTACT_FORM_ID = 6;

// used on the RevenueCat x Paddle Contact Us page in the Hero component
const PADDLE_FORM_ID = 26;

// used for the Subscribe components
const SUBSCRIBE_FORM_ID = 7;

// used for the updated Home page hero form
const SUBSCRIBE_HOME_FORM_ID = 16;

// used on the Report page (/state-of-subscription-apps) in the Hero component and for the Download Form lazy-blocks
const DOWNLOAD_FORM_ID = 8;

// used on the Report 2024 page (/state-of-subscription-apps-2024) in the Hero component and for the Download Form lazy-blocks
const DOWNLOAD_FORM_2024_ID = 15;

// used on the Report 2024 page (jp/state-of-subscription-apps-2024) in the Hero component and for the Download Form lazy-blocks
const DOWNLOAD_FORM_2024_V2_ID = 18;

// used on the Report 2025 page (/state-of-subscription-apps-2025) in the Hero component and for the Download Form lazy-blocks
const DOWNLOAD_FORM_2025_ID = 25;

// used on the Test Report 2024 page (/state-of-subscription-apps-2024-test-copy) in the Hero component and for the Download Form lazy-blocks
const DOWNLOAD_FORM_TEST_PAGE_ID = 19;

// used on the Calculator page (/calculator) in the Hero component
const CALCULATOR_FORM_ID = 10;

// used for the Subscribe components on the blog and blog-post page
const BLOG_POST_SUBSCRIBE_FORM_ID = 11;

// used on the Request Demo page (/demo) in the Hero component
const DEMO_FORM_ID = 12;

// used on the Why RevenueCat page (/why-revenuecat) in the Hero component and for the shared RequestDemo component
const REQUEST_DEMO_FORM_ID = 13;

// used on the Custom Report page (/custom-report) in the Hero component
const CUSTOM_REPORT_DEMO_REQUEST_FORM_ID = 22;

// used on the blog post with Growth category
const SUBSCRIBE_SUB_CLUB_EMAIL_FORM_ID = 24;

// used on the Experiment page (/experiment) in the Hero component
const EXPERIMENT_REQUEST_FORM_ID = 27;

// Read more: https://developer.apple.com/documentation/appstorereceipts/status
const APP_STATUS_CODES = {
  21000: 'The App Store could not read the JSON object you provided.',
  21002: 'The data in the receipt-data property was malformed or missing.',
  21003: 'The receipt could not be authenticated.',
  21004:
    'The shared secret you provided does not match the shared secret on file for your account.',
  21005: 'The receipt server is not currently available.',
  21006:
    'This receipt is valid but the subscription has expired. When this status code is returned to your server, the receipt data is also decoded and returned as part of the response.\n\nOnly returned for iOS 6 style transaction receipts for auto-renewable subscriptions.',
  21007:
    'This receipt is from the test environment, but it was sent to the production environment for verification. Send it to the test environment instead.',
  21008:
    'This receipt is from the production environment, but it was sent to the test environment for verification. Send it to the production environment instead.',
  21010:
    'This receipt could not be authorized. Treat this the same as if a purchase was never made.',
  DEFAULT: 'Internal data access error.',
};

const COUNTRIES = [
  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Asia/Pacific Region',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'British Virgin Islands',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo',
  'Costa Rica',
  "Cote D'ivoire",
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern and Antarctic Lands',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia (FYROM)',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Helena',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Pierre and Miquelon',
  'Saint Vincent and The Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and The South Sandwich Islands',
  'South Korea',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Eswatini',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Timor-leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'U.S. Virgin Islands',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

const URL_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];

const REPORT_ENTERPRISE_EMAILS = [
  '18birdies.com',
  '1password.com',
  '1stphorm.com',
  '2go.com',
  '44pixels.ai',
  'a1apps.co',
  'abceed.com',
  'abcmouse.com',
  'abema.tv',
  'accordmobi.com',
  'accuweather.com',
  'active.com',
  'mobilestudio.cc',
  'adhoclabs.co',
  'adopteunmec.com',
  'affinityclick.com',
  'aiby.com',
  'aipicplus.com',
  'airbrush.com',
  'airemodel.pro',
  'aiwit.cc',
  'alar.my',
  'aliveapp.co',
  'allconnected.co',
  'alltrails.com',
  'amazia.co.jp',
  'amazon.com',
  'amcnetworks.com',
  'amcplus.com',
  'ancestry.com',
  'anghami.com',
  'app.polybuzz.ai',
  'appewa.com',
  'appnation.co',
  'arlo.com',
  'asanarebel.com',
  'asken.jp',
  'askendiet.com',
  'asknebula.com',
  'audible.com',
  'audiobooks.com',
  'audioteka.com',
  'avast.com',
  'awa.fm',
  'azarlive.com',
  'b612.snow.me',
  'babbel.com',
  'badoo.com',
  'bandlab.com',
  'bark.us',
  'basenjiapps.com',
  'beautyplus.com',
  'beenverified.com',
  'begamob.com',
  'beinmediagroup.com',
  'bet.com',
  'betterme.world',
  'bettersleep.com',
  'bigten.com',
  'bild.de',
  'billdu.com',
  'blinkforhome.com',
  'blinkist.com',
  'blk-app.com',
  'bloomberg.com',
  'boards.com',
  'bodytuneapp.com',
  'booksy.com',
  'bpmobile.com',
  'brainimpulse.me',
  'breakpointstudio.com',
  'breethe.com',
  'britbox.com',
  'budgestudios.com',
  'bumble.com',
  'burnerapp.com',
  'busuu.com',
  'bytezza.com',
  'calai.app',
  'calimoto.com',
  'calm.com',
  'camscanner.com',
  'canva.com',
  'care.com',
  'chatyapp.com',
  'chegg.com',
  'citizen.com',
  'clapperapp.com',
  'claude.ai',
  'climeradar.com',
  'cnbc.com',
  'codeway.co',
  'coffeemeetsbagel.com',
  'coinidentifierai.com',
  'comfax.com',
  'conlanapps.net',
  'connected2.me',
  'cookidoo.co.uk',
  'cookpad.com',
  'coomeet.com',
  'copilot.money',
  'costarastrology.com',
  'coursehero.com',
  'coursera.org',
  'covenanteyes.com',
  'cozi.com',
  'crave.ca',
  'crazymaplestudios.com',
  'cricut.com',
  'cronometer.com',
  'crunchyroll.com',
  'cyberghostvpn.com',
  'dancefit.me',
  'dashlane.com',
  'datemyage.com',
  'dating.com',
  'davinci.ai',
  'dayoneapp.com',
  'dazn.com',
  'deezer.com',
  'desidari.com',
  'digital.joinform.co',
  'dilmil.co',
  'dingtone.me',
  'surfline.com',
  'discoveryplus.com',
  'disneyplus.com',
  'docs.qq.com',
  'docusign.com',
  'dovly.com',
  'downapp.com',
  'downdogapp.com',
  'wippy.io',
  'dramabox.com',
  'dramashorts.io',
  'dreame.com',
  'dreameshort.com',
  'dropbox.com',
  'dropout.tv',
  'drumpadapps.com',
  'duetapp.net',
  'duolingo.com',
  'economist.com',
  'eero.com',
  'eharmony.com',
  'elsanow.io',
  'elsaspeak.com',
  'enerjoy.life',
  'engbright.com',
  'epop.ai',
  'eufylife.com',
  'eure.jp',
  'everlance.com',
  'evernote.com',
  'evolly.app',
  'expressvpn.com',
  'faceapp.com',
  'falconcleaner.com',
  'faliane.com',
  'family-album.com',
  'fb.omiai-jp.com',
  'fdfd.me',
  'feeld.co',
  'finanzguru.de',
  'findmykids.org',
  'fitbod.me',
  'flextv.cc',
  'flickreels.net',
  'flightradar24.com',
  'flighty.com',
  'flightyapp.com',
  'flitsmeister.nl',
  'flo.health',
  'florate.io',
  'flosports.tv',
  'flowkey.com',
  'fontskeyboard.com',
  'foreflight.com',
  'fox.com',
  'foxnews.com',
  'freee.co.jp',
  'freeletics.com',
  'freevpnapp.org',
  'frontierdesign.com',
  'fruitz.io',
  'ft.com',
  'fujitv.co.jp',
  'fungames-forfree.com',
  'furyu.jp',
  'gaia.com',
  'gaiagps.com',
  'garmin.com',
  'gauthmath.com',
  'gc.com',
  'geocaching.com',
  'getcircuit.com',
  'getechglobal.ltd',
  'getepic.com',
  'getglam.app',
  'getkeepsafe.com',
  'getonce.com',
  'getpaid.io',
  'gismart.com',
  'globo.com',
  'gmx.com',
  'gmx.it',
  'go-text.me',
  'golfshot.com',
  'gomining.com',
  'goodnovel.com',
  'gopro.com',
  'gothamsports.com',
  'gotokeep.com',
  'grammarly.com',
  'grindr.com',
  'hallow.com',
  'happn.com',
  'hayu.com',
  'hbo.com',
  'headspace.com',
  'helloclue.com',
  'hellosimply.com',
  'hellotalk.com',
  'hidive.com',
  'hily.com',
  'hinge.co',
  'hotspotshield.com',
  'hotstar.com',
  'hubx.co',
  'hudapp.com',
  'hulu.com',
  'huntwise.com',
  'idealabs.mobi',
  'ifit.com',
  'iheart.com',
  'imvu.com',
  'inshot.cc',
  'insighttimer.com',
  'instasize.com',
  'Instories.com',
  'intuit.com',
  'invoice.2go.com',
  'invoicesimple.com',
  'iq.com',
  'irontech.mobi',
  'iteration-mobile.com',
  'itranslate.com',
  'itv.com',
  'j-plus.net',
  'joinfambase.com',
  'joist.com',
  'joox.com',
  'joyce.app',
  'joyn.de',
  'joyread.com',
  'kainsuite.com',
  'kakao.com',
  'kakaocorp.com',
  'kakaoent.com',
  'kalostv.com',
  'kayosports.com.au',
  'keepersecurity.com',
  'keiki.app',
  'kick.com',
  'kiddopia.com',
  'kik.com',
  'kismia.com',
  'kkbox.com',
  'komoot.com',
  'landglide.com',
  'lastpass.com',
  'leaphealth.fitness',
  'lefigaro.fr',
  'legendarysoftwarelabs.com',
  'lemonde.fr',
  'lequipe.fr',
  'life360.com',
  'lifesum.com',
  'lift.bio',
  'liftstory.com',
  'lightricks.com',
  'line.me',
  'lingokids.com',
  'literiess.com',
  'litres.ru',
  'livelycycle.com',
  'loseit.com',
  'lovekeyboard.com',
  'lovoo.com',
  'lp.pigg-party.com',
  'lumos.mobi',
  'lumosity.com',
  'lyrebirdstudio.net',
  'm.anystories.app',
  'm6.fr',
  'makeheadway.com',
  'mangabox.me',
  'marcopolo.me',
  'marzenmedia.com',
  'masterclass.com',
  'match.com',
  'mathway.com',
  'max.com',
  'mcafee.com',
  'mebmarket.com',
  'mediaradiance.com',
  'medium.com',
  'meetcarrot.com',
  'meetic-europe.com',
  'meetic.com',
  'meetme.com',
  'meetup.com',
  'mega.io',
  'megogo.net',
  'meitu.com',
  'mi.com',
  'mileiq.com',
  'minichat.com',
  'minimodev.com',
  'mirrativ.com',
  'mixch.tv',
  'mlb.com',
  'mobilecleverapps.com',
  'mobilejump.mobi',
  'moboreader.net',
  'molotov.tv',
  'moncoyote.com',
  'mondly.com',
  'moneyforward.com',
  'motogp.com',
  'mtch.com',
  'mubi.com',
  'mullvad.net',
  'musescore.com',
  'music.line.me',
  'music.yandex.com',
  'musicworldmedia.com',
  'muzz.com',
  'mwm.ai',
  'mycarly.com',
  'mydramawave.com',
  'myfitnesspal.com',
  'myheritage.com',
  'mynetdiary.com',
  'myplantin.com',
  'myradar.com',
  'myrocketnetworkaccelerator.com',
  'nanit.com',
  'naturalcycles.com',
  'naverz-corp.com',
  'navionics.com',
  'nba.com',
  'netdreamers.co.jp',
  'netshort.com',
  'newyorker.com',
  'nfl.com',
  'NightSky.com',
  'noom.com',
  'nordvpn.com',
  'nove8.com',
  'novellairs.com',
  'nowthatstv.net',
  'nowthatstvplus.com',
  'nowtv.com',
  'nugs.net',
  'nutracheck.co.uk',
  'nutracheck.com',
  'nytcooking.com',
  'nytimes.com',
  'obrio.co',
  'offerup.com',
  'okcupid.com',
  'omi.sg',
  'on5mobile.com',
  'onelightapps.io',
  'onepeloton.com',
  'onluxy.com',
  'onoff.app',
  'onxmaps.com',
  'optus.com.au',
  'ordnancesurvey.co.uk',
  'osmaps.co.uk',
  'osn.com',
  'otter.ai',
  'ozuna.app',
  'p.kdocs.cn',
  'pairs.lv',
  'pandora.com',
  'paperlesspost.com',
  'paramountplus.com',
  'peacocktv.com',
  'perfectcorp.com',
  'philo.com',
  'pho.to',
  'phonecleaner.app',
  'photogrid.app',
  'photomyne.com',
  'piccollage.com',
  'picsart.com',
  'picturethisai.com',
  'pimsleur.com',
  'pinger.com',
  'pixiv.net',
  'pixverse.ai',
  'planner5d.com',
  'platforms.wsj.com',
  'plaud.ai',
  'playlet.com',
  'plus.rtl.de',
  'pocket.shonenmagazine.com',
  'pocketfm.com',
  'pococha.com',
  'podimo.com',
  'podme.com',
  'poe.com',
  'pof.com',
  'pokecolo.jp',
  'pokekara.com',
  'poly.cam',
  'popixels.com',
  'powerfulclean.xyz',
  'premom.com',
  'prequel.app',
  'prequelapp.com',
  'prisma-ai.com',
  'privatephotovault.com',
  'promova.com',
  'prosepetal.top',
  'protonvpn.com',
  'pulseheartcheck.com',
  'pure.app',
  'questionai.com',
  'quickbooks.intuit.com',
  'quizlet.com',
  'quora.com',
  'radiko.jp',
  'ramseysolutions.com',
  'rayatheapp.com',
  'readdle.com',
  'reality.app',
  'reelshort.com',
  'reface.ai',
  'remhopte.com',
  'remini.ai',
  'replika.ai',
  'reviva.works',
  'ridewithgps.com',
  'ridibooks.com',
  'ridicorp.com',
  'rocketmoney.com',
  'roomplannerapp.com',
  'rosettastone.com',
  'rtl.de',
  'rubylife.com',
  'rumble.com',
  's.awa.fm',
  'salams.app',
  'scanqrcodeapp.com',
  'scribd.com',
  'scruff.com',
  'seekingalpha.com',
  'serasa.com.br',
  'serealplus.com',
  'sevenmileapps.com',
  'sfr.fr',
  'shaadi.com',
  'shahid.mbc.net',
  'shonenjump.viz.com',
  'shonenjumpplus.com',
  'shoptezza.com',
  'shortswave.com',
  'shorttv.live',
  'signnow.com',
  'siriusxm.com',
  'sites.google.com',
  'sky.com',
  'skylightframe.com',
  'skype.com',
  'skyshowtime.com',
  'sleepcycle.com',
  'sleepwatchapp.com',
  'smule.com',
  'snackshort.tv',
  'snap-shorts.com',
  'snow.me',
  'solvely.ai',
  'soulchill.live',
  'soundcloud.com',
  'sp.lnln.jp',
  'sparkdyn.com',
  'speakapp.com',
  'speechblubs.com',
  'speechify.com',
  'spiegel.de',
  'spliceapp.com',
  'splitwise.com',
  'spooncast.net',
  'sport.optus.com.au',
  'sportsnet.ca',
  'spotvnow.co.kr',
  'stardusttv.cc',
  'starmakerstudios.com',
  'starz.com',
  'starzplay.com',
  'storytel.com',
  'strava.com',
  'strong.app',
  'subscriptions.seekingalpha.com',
  'superlivellc.com',
  'support.scribd.com',
  'surfline.com',
  'surfshark.com',
  'sweat.com',
  'tabelog.com',
  'tabii.com',
  'tagged.com',
  'taimi.com',
  'tantanapp.com',
  'tap.pm',
  'tapas.io',
  'tapo.com',
  'tapon.com',
  'tapple.co.jp',
  'tapple.me',
  'tappytoon.com',
  'team2swift.com',
  'terabox.com',
  'textnow.com',
  'tf1.com',
  'tf1.fr',
  'thebeachbodycompany.com',
  'theepochtimes.com',
  'theguardian.com',
  'theinnercircle.co',
  'theleague.com',
  'thepattern.com',
  'thermomix.com',
  'thewonderweeks.com',
  'thezeusnetwork.com',
  'ticktick.com',
  'tidal.com',
  'tile.com',
  'tinder.com',
  'tinyscan.app',
  'tod.tv',
  'todtv.com.tr',
  'tofu.com',
  'toggleapps.io',
  'tomtom.com',
  'toplive.io',
  'totalav.com',
  'tradingview.com',
  'trailforks.com',
  'trainingpeaks.com',
  'truckerpath.com',
  'truecaller.com',
  'tryquinn.com',
  'tving.com',
  'twitcasting.tv',
  'udemy.com',
  'UFC.com',
  'ultimate-guitar.com',
  'unext.jp',
  'v.sayhi.app',
  'viaplay.com',
  'viaplaygroup.com',
  'viber.com',
  'video.unext.jp',
  'vidio.com',
  'vids-app.com',
  'viki.com',
  'viu.com',
  'vivavideo.tv',
  'vix.com',
  'vixerapp.com',
  'viz.com',
  'vk.com',
  'vpnproxymaster.com',
  'vulcanlabs.co',
  'wakingup.com',
  'wanderlog.com',
  'waplog.com',
  'washingtonpost.com',
  'melissawoodhealth.com',
  'watcha.com',
  'wavve.com',
  'weathernews.com',
  'weathernews.jp',
  'webfic.com',
  'webnovel.com',
  'webtoons.com',
  'wechat.com',
  'wefaaq.co',
  'weightwatchers.com',
  'skysportnow.co.nz',
  'welltech.com',
  'welltory.com',
  'weplayapp.com',
  'wetv.vip',
  'weverse.io',
  'whoscall.com',
  'wikiloc.com',
  'willow.tv',
  'windy.app',
  'windy.com',
  'wizzapp.com',
  'wondery.com',
  'woofz.com',
  'worldofwonder.com',
  'wowpresentsplus.com',
  'wowtv.de',
  'wsj.com',
  'wyze.com',
  'x.ai',
  'x.com',
  'xvpn.io',
  'yalla.com',
  'yawentv.com',
  'yazio.com',
  'yitechnology.com',
  'ynab.com',
  'yoho.media',
  'youneedabudget.com',
  'yousician.com',
  'youtube.com',
  'yubo.live',
  'yuka.io',
  'zepeto.me',
  'zilingial.com',
  'zoosk.com',
  'zwift.com',
];

const SEGMENT_ANON_ID = 'segment_anon_id__c';

export {
  BUTTON_SUCCESS_TIMEOUT_MS,
  FORM_PORTAL_ID,
  CONTACT_FORM_ID,
  PADDLE_FORM_ID,
  DEMO_FORM_ID,
  SUBSCRIBE_FORM_ID,
  SUBSCRIBE_HOME_FORM_ID,
  BLOG_POST_SUBSCRIBE_FORM_ID,
  REQUEST_DEMO_FORM_ID,
  DOWNLOAD_FORM_ID,
  DOWNLOAD_FORM_2024_ID,
  DOWNLOAD_FORM_2024_V2_ID,
  DOWNLOAD_FORM_2025_ID,
  DOWNLOAD_FORM_TEST_PAGE_ID,
  CALCULATOR_FORM_ID,
  TALK_TO_SALES_FORM_ID,
  BOOK_A_DEMO_FORM_ID,
  GET_A_DEMO_FORM_ID,
  REQUEST_A_MIGRATION_PLAN_FORM_ID,
  BECOME_A_PARTNER_FORM_ID,
  BECOME_A_PARTNER_FORM_SMALL_ID,
  CUSTOM_REPORT_DEMO_REQUEST_FORM_ID,
  SUBSCRIBE_SUB_CLUB_EMAIL_FORM_ID,
  EXPERIMENT_REQUEST_FORM_ID,
  APP_STATUS_CODES,
  COUNTRIES,
  URL_PARAMS,
  REPORT_ENTERPRISE_EMAILS,
  SEGMENT_ANON_ID,
};
